import React from 'react'
import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import ModuleEdit from './ModuleEdit';
import ModuleDel from './ModuleDel';
import SubmoduleAdd from '../submodule/SubmoduleAdd';

function ModuleDropdown(props) {
    const items = [
        {
            label: (
                <ModuleEdit 
                    bgn_id={props.bgn_id}                                                     
                    bgn_name={props.bgn_name} 
                    bg_id={props.bg_id}
                    bg_name={props.bg_name}
                    bg_dept_id={props.bg_dept_id}
                    bg_dept_name={props.bg_dept_name}
                />
            ),
            key: 'ModuleEdit',
        },
        {
            label: (
                <ModuleDel bgn_id={props.bgn_id}/>
            ),
            key: 'ModuleDel',
        },      
        {
            type: 'divider',
        }, 
        {
            label: (
                <SubmoduleAdd
                    bgn_id={props.bgn_id}                                                     
                    bgn_name={props.bgn_name} 
                    bg_id={props.bg_id}
                    bg_name={props.bg_name}
                    bg_dept_id={props.bg_dept_id}
                    bg_dept_name={props.bg_dept_name}
                />
            ),
            key: 'SubmoduleAdd',
        }, 
    ];
    return (
        <Dropdown menu={{ items }} trigger={['click']}>
            <a onClick={e => e.preventDefault()}> <EllipsisOutlined /></a>
        </Dropdown>
    )
}

export default ModuleDropdown